<!-- lay betslip -->
<div class="row mx-0 align-items-center" *ngIf="betData && betData?.price && betData?.isClosed == false">
  <div id="goto-{{betData?.market_id}}-{{betData?.selection_id}}"></div>
  <div class="col-12 text-right betslip px-0" [ngClass]="betData.side.includes('b') ? 'bs-back' : 'bs-lay'">
      <!-- note: back betslip for bs-back and lay betslip for bs-lay -->
      <div class="row justify-content-end align-items-center mx-0">
          <div class="col-md-7 pl-0 pr-1">
              <span class="bs-title">{{betData?.event_name}} - {{betData.name}}</span>
          </div>
          <div class="col-md-5 d-flex align-items-center px-0 justify-content-center">
              <div class="input-group">
                  <div class="input-group-prepend" [ngClass]="{'disabled-cls' : betData.key == 'fancy'}" (click)="onChangeOdds('down')">
                      <span class="input-group-text bs-minus">-</span>
                  </div>
                  <input type="number" class="form-control" [disabled]="betData.key == 'fancy'" [(ngModel)]="betData.price" (change)="validateField()" min="1.01" max="999.99">
                  <div class="input-group-prepend" [ngClass]="{'disabled-cls' : betData.key == 'fancy'}" (click)="onChangeOdds('up')">
                      <span class="input-group-text bs-plus">+</span>
                  </div>
              </div>
              <div class="input-group">
                  <div class="input-group-prepend">
                      <span class="input-group-text bs-minus">-</span>
                  </div>
                  <input type="number" pattern="[0-9]*" class="form-control" (keypress)="digitOnly($event)" (keydown)="validateField()" (keyup)="validateField()" (change)="validateField()" [(ngModel)]="betData.stake" min="0" placeholder="Min Stake: 000">
                  <div class="input-group-prepend">
                      <span class="input-group-text bs-plus">+</span>
                  </div>
              </div>
          </div>
      </div>
      <div class="row justify-content-end align-items-center mx-0">
          <div class="col-md-9 px-0 mb-1">
              <div class="btn-group btnStakes">
                  <button type="button" class="btn" (click)="onAmountChange(stk)" *ngFor="let stk of betData.stakes;">{{stk.name}}</button>
              </div>
          </div>
          <div class="col-md-9 px-0">
            <div class="btn-group btnStakes">
                <button type="button" class="btn min-btn" (click)="onMinMaxAmountChange(betData?.min)">MIN</button>
                <button type="button" class="btn max-btn" (click)="onMinMaxAmountChange(betData?.max)">MAX</button>
                <button type="button" class="btn all-btn" *ngIf="isLogin()" (click)="onAllInAmountChange()">ALL IN</button>
                <button type="button" class="btn clear-btn" (click)="onClear()">CLEAR</button>
            </div>
          </div>
          <!-- <div class="ctm-stks-mv">
              <table class="w-100 text-black w-100 font-weight-bold br-1-bl">
                  <tr class="br-bottom">
                      <td class="br-right"><span>1</span></td>
                      <td class="br-right"><span>2</span></td>
                      <td class="br-right"><span>3</span></td>
                      <td class="br-right"><span>4</span></td>
                      <td class="br-right"><span>5</span></td>
                      <td class="br-right"><span>6</span></td>
                      <td rowspan="2" class="csmv-img"><span>
                        <img alt=""src="https://images.staticcontents.com/rde/uimg/bt-icon.jpg"></span>
                      </td>
                  </tr>
                  <tr>
                      <td class="br-right"><span>7</span></td>
                      <td class="br-right"><span>8</span></td>
                      <td class="br-right"><span>9</span></td>
                      <td class="br-right"><span>0</span></td>
                      <td class="br-right"><span>00</span></td>
                      <td class="br-right"><span>.</span></td>
                  </tr>
              </table>
          </div> -->
          <div class="col-md-3 px-md-0 px-1">
              <div class="btn-group btns-access">
                  <button type="button" class="btn btn-placebet" [disabled]="betData.disabled || isLoading" (click)="orderPlaced()">place bet</button>
                  <button type="button" class="btn btn-canceled" (click)="onCloseBet($event)">cancel</button>
              </div>
          </div>
      </div>
      <!-- loader -->
      <div class="loader" *ngIf="isLoading">
        <span>place your bet, please wait...</span>
        <div class="spinner-border"></div>
      </div>
      <!-- loader -->
  </div>
</div>
<!-- betslip -->
